import type { FC, ReactNode } from 'react';

import { bloom } from '@/ui/theme/colors';

interface CoverBackgroundProps {
  children: ReactNode;
  className?: string;
}

// Survey cover art drawn with design-system tokens (bloom palette) instead of a
// bitmap, so it stays in step with the theme. Three overlapping organic shapes.
const CoverBackground: FC<CoverBackgroundProps> = ({
  children,
  className = '',
}) => (
  <div className={`relative overflow-hidden ${className}`}>
    <svg
      className="absolute inset-0 size-full"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 1000 500"
      aria-hidden
    >
      <rect fill={bloom[300]} height="500" width="1000" />
      <path
        d="M520 0 H700 C730 50 820 95 890 115 C980 140 1000 190 1000 190 V500 H780 Z"
        fill={bloom[400]}
      />
      <path
        d="M0 0 H520 C560 50 660 80 760 95 C880 118 960 200 940 330 C925 420 880 470 860 500 H0 Z"
        fill={bloom[500]}
      />
    </svg>
    <div className="relative size-full">{children}</div>
  </div>
);

export default CoverBackground;
